module.exports = __webpack_public_path__ + "static/media/29COICT5.26979524.jpg";